import { fromJS } from 'immutable'

const initialState = fromJS({
    available: [/*{ weekDay: 0, hours: [] }*/],
    blockDates: ['ok'/*{ timestamp: 0, string: '' }*/],
    schedule: []
})

const appschedule = (state = initialState, action) => {
    switch (action.type) {
        case "SET_DAY_HOURS":
            return state.merge({
                available: action.payload.available,
                id: action.payload.id
            })
        case "SET_BLOCK_DATE":
            return state.merge({
                blockDates: action.payload
            })
        case "CLEAR_SCHEDULE":
            return state.merge({
                available: [],
                blockDates: ['ok'],
                id: false,
                key: false,
                uid: false
            })
        case "SET_SCHEDULE":
            return state.merge({
                ...action.payload
            })
        default:
            return state
    }
}

export default appschedule